module.exports = __webpack_public_path__ + "fonts/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4iaVIGxA.daafcec.woff2";